/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function Seo({
  description,
  lang,
  meta,
  title,
  includeTitle,
  includeDescription,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const documentTitle = defaultTitle
    ? title === "Home"
      ? defaultTitle
      : `${title} | ${defaultTitle}`
    : title
  const metadata = [
    {
      property: `og:title`,
      content: documentTitle,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      name: "og:image",
      content:
        "https://www.rockybrands.com/static/3e70b5a2e03f923a76a2aac294e331cd/4cba4/carousel-image-3-DT.webp",
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata?.author || ``,
    },
    {
      name: `twitter:title`,
      content: documentTitle,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      name: `referrer`,
      content: `strict-origin-when-cross-origin`,
    },
  ].concat(meta)

  return (
    <>
      <html lang={lang} />
      {includeTitle && <title>{documentTitle}</title>}
      {includeDescription && <meta name="description" content={metaDescription} />}
      {metadata.map((metaItem, index) => (
        <meta key={`${metaItem.name || metaItem.property}-${index}`} {...metaItem} />
      ))}
    </>
  )
}

Seo.defaultProps = {
  lang: `en-US`,
  meta: [],
  description: ``,
  includeTitle: true,
  includeDescription: true,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  includeTitle: PropTypes.bool,
  includeDescription: PropTypes.bool,
}

export default Seo
